import React from "react";
import { Form, Col, Row } from "react-bootstrap";

export function DocumentInfoForm({
  handleChange,
  values
 }) {
  const preRegistrationFormSerialNumber = values.preRegistrationFormSerialNumber != null ? values.preRegistrationFormSerialNumber : "";
  const preRegistrationFormSerialNumberNext = values.preRegistrationFormSerialNumberNext != null ? values.preRegistrationFormSerialNumberNext : "";
  const billNo = values.billNo != null ? values.billNo : "";
  const billNoNext = values.billNoNext != null ? values.billNoNext : "";

  return (
    <>
      <Form.Group as={Row} controlId="preRegistrationFormSerialNumber">
        <Form.Label column sm={4}>
          Kayıt Ön Form Seri No
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="number" min={1} value={preRegistrationFormSerialNumber} placeholder="Kayıt Ön Form Seri No" onChange={handleChange} />
        </Col>
      </Form.Group>
                    
      <Form.Group as={Row} controlId="preRegistrationFormSerialNumberNext">
        <Form.Label column sm={4}>
          Sıradaki
        </Form.Label>
        <Col sm={8}>
          <Form.Control value={preRegistrationFormSerialNumberNext} placeholder="Sıradaki" readOnly />
        </Col>
      </Form.Group>
                    
      <Form.Group as={Row} controlId="billNo">
        <Form.Label column sm={4}>
          Senet No
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="number" min={1} value={billNo} placeholder="Senet No" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="billNoNext">
        <Form.Label column sm={4}>
          Sıradaki
        </Form.Label>
        <Col sm={8}>
          <Form.Control value={billNoNext} placeholder="Sıradaki" readOnly />
        </Col>
      </Form.Group>
    </>        
  );
}